import Joi from 'joi';
import { objectId } from '@/shared/validations/custom.validation';

export const subCategoryValidation = {
  // GET by ID (params)
  get: Joi.object({
    id: Joi.string().custom(objectId).required(),
  }).unknown(true),
  query: Joi.object().unknown(true),

  // CREATE
  create: Joi.object({
    name: Joi.string().trim().lowercase().required(),
    categoryId: Joi.string().custom(objectId).required(),
    createdBy: Joi.string().custom(objectId).optional(),
    updatedBy: Joi.string().custom(objectId).optional(),
  }),

  // UPDATE
  update: {
    params: Joi.object({
      id: Joi.string().custom(objectId).required(),
    }).unknown(true),
    body: Joi.object({
      name: Joi.string().trim().lowercase().optional(),
      categoryId: Joi.string().custom(objectId).optional(),
      updatedBy: Joi.string().custom(objectId).optional(),
    }),
  },

  // DELETE
  delete: Joi.object({
    id: Joi.string().custom(objectId).required(),
  }),
};
